import React, { useState } from 'react';
import { QUOTES } from '../data';
import { IconToday, IconJournal, IconGoals, IconLibrary, IconSun } from './Icons';

export default function Landing({ onSignup, onLogin }) {
  const [selectedPlan, setSelectedPlan] = useState('monthly');
  const q = QUOTES[0];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#FFFFFF' }}>

      {/* Hero */}
      <div style={{ padding: '56px 28px 32px', textAlign: 'center', borderBottom: '1px solid #F5F3F0' }}>
        <img src="/logo-transparent.png" alt="Be Here Now" style={{ width: 110, height: 'auto', marginBottom: 22 }} onError={e => { e.target.style.display = 'none'; }} />
        <div className="brand-small" style={{ marginBottom: 10 }}>Be Here Now</div>
        <div style={{ fontSize: 32, fontWeight: 800, color: '#111', letterSpacing: '-0.8px', lineHeight: 1.15, marginBottom: 14 }}>A grounded daily practice,<br />all in one place.</div>
        <div style={{ fontSize: 14, color: '#777', lineHeight: 1.8, maxWidth: 290, margin: '0 auto' }}>Daily practice, guided reflection, and intentions — rooted in wholeness.</div>
      </div>

      {/* Quote */}
      <div style={{ padding: '24px 28px 0' }}>
        <div className="quote-card">
          <div className="quote-text">{q.text}</div>
          {q.author && <div className="quote-author">— {q.author}</div>}
        </div>

        {/* Features */}
        <div className="section-label">What's inside</div>
        <div className="landing-features">
          {[
            [<IconToday size={18} color="#333" />, 'Daily Practice — a gentle monthly rhythm'],
            [<IconJournal size={18} color="#333" />, 'Reflection — daily, weekly, and open space'],
            [<IconGoals size={18} color="#333" />, 'Intentions — what\'s calling you, and a vision board'],
            [<IconLibrary size={18} color="#333" />, 'A library of wellness books — 20 books, 84 practices'],
            [<IconSun size={18} color="#333" />, 'Built for steady, returning practice'],
          ].map(([icon, text], i) => (
            <div key={i} className="landing-feature">
              <span style={{ flexShrink: 0 }}>{icon}</span>
              <span style={{ fontSize: 14 }}>{text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div style={{ padding: '28px 28px 48px', marginTop: 'auto' }}>
        {/* Plan selector */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          <div
            onClick={() => setSelectedPlan('monthly')}
            style={{ flex: 1, border: `1.5px solid ${selectedPlan === 'monthly' ? '#3A6A2A' : '#E0DDD8'}`, borderRadius: 12, padding: '14px 12px', cursor: 'pointer', background: selectedPlan === 'monthly' ? '#F8FCF6' : '#FFFFFF', transition: 'all .15s' }}
          >
            <div style={{ fontSize: 10, letterSpacing: '.1em', textTransform: 'uppercase', color: '#A09888', fontWeight: 600, marginBottom: 4 }}>Monthly</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#111', letterSpacing: '-.5px' }}>$5</div>
            <div style={{ fontSize: 11, color: '#A09888' }}>per month</div>
          </div>
          <div
            onClick={() => setSelectedPlan('annual')}
            style={{ flex: 1, border: `1.5px solid ${selectedPlan === 'annual' ? '#3A6A2A' : '#E0DDD8'}`, borderRadius: 12, padding: '14px 12px', cursor: 'pointer', background: selectedPlan === 'annual' ? '#F8FCF6' : '#FFFFFF', transition: 'all .15s', position: 'relative' }}
          >
            <div style={{ position: 'absolute', top: -10, right: 10, background: '#3A6A2A', color: 'white', fontSize: 9, fontWeight: 700, padding: '3px 8px', borderRadius: 100, letterSpacing: '.06em' }}>2 MONTHS FREE</div>
            <div style={{ fontSize: 10, letterSpacing: '.1em', textTransform: 'uppercase', color: '#A09888', fontWeight: 600, marginBottom: 4 }}>Annual</div>
            <div style={{ fontSize: 20, fontWeight: 800, color: '#111', letterSpacing: '-.5px' }}>$50</div>
            <div style={{ fontSize: 11, color: '#A09888' }}>per year</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18 }}>
          <div style={{ background: '#F0F7EC', color: '#2A5A1A', fontSize: 12, fontWeight: 600, padding: '6px 16px', borderRadius: 100 }}>Free for 7 days</div>
          <div style={{ fontSize: 13, color: '#A09888' }}>no charge until day 8</div>
        </div>
        <button className="btn-primary" style={{ fontSize: 15, padding: '16px' }} onClick={() => onSignup(selectedPlan)}>Start free trial — no charge today</button>
        <button className="btn-secondary" onClick={onLogin}>I already have an account</button>
        <div style={{ background: '#F8FCF6', border: '1px solid #E8F0E4', borderRadius: 10, padding: '12px 16px', marginTop: 12, textAlign: 'center' }}>
          <div style={{ fontSize: 12, color: '#3A6A2A', fontWeight: 600, marginBottom: 4 }}>📧 Check your email after signing up</div>
          <div style={{ fontSize: 11, color: '#777', lineHeight: 1.7 }}>After entering your details, you'll receive a confirmation email to set your password and activate your account.</div>
        </div>
        <div style={{ textAlign: 'center', fontSize: 11, color: '#C8C4BE', marginTop: 10, lineHeight: 1.7 }}>
          By continuing you agree to our Terms & Privacy Policy.<br />Billed via Stripe through Outseta after 7-day trial.
        </div>
      </div>
    </div>
  );
}
